import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': SessionManager.getCookie('user_token'),
})

export const contactUsList = createAsyncThunk('contact_us/list', async ({ pageable: data, navigate }) => {
    try {
        return await axios({
            method: 'GET',
            url: getConfig.API_URL + 'contact_us',
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
            },
            headers: headers(),
        })
    } catch (error) {
        return error.response
    }
})

export const contactUsDetails = createAsyncThunk('contact_us/details', async ({ id, navigate }) => {
    try {
        return await axios({
            method: 'GET',
            url: getConfig.API_URL + `contact_us/${id}`,
            headers: headers(),
        })
    } catch (error) {
        return error.response
    }
})

const handleAuthError = (action) => {
    if (action?.payload?.status === 401) {
        showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
    } else if (action?.payload?.status === 403) {
        showAccessDeniedAlert(action.meta.arg.navigate)
    }
}

const contact_us = createSlice({
    name: 'contact_us',
    initialState: {
        list: [],
        details: null,
    },
    reducers: {
        clearContactUsDetails: (state) => {
            state.details = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(contactUsList.fulfilled, (state, action) => {
                if (action?.payload?.status === 200) {
                    state.list = action.payload.data.data || []
                } else {
                    state.list = []
                    handleAuthError(action)
                }
            })
            .addCase(contactUsDetails.fulfilled, (state, action) => {
                if (action?.payload?.status === 200) {
                    state.details = action.payload.data.data || null
                } else {
                    state.details = null
                    handleAuthError(action)
                }
            })
    },
})

export const { clearContactUsDetails } = contact_us.actions;
export default contact_us.reducer;